import React, { useEffect, useState } from "react";
import { Button, Descriptions, Divider, Drawer, Image, Input, InputNumber } from "antd";
import { SplitCellsOutlined } from "@ant-design/icons";
import { UpdateSplitOrder } from "./functions/UpdateSplitOrder";

const { TextArea } = Input;

const SplitOrderDrawer = ({ orderData, user, setOpen }) => {
  const [rollsCreated, setRollsCreated] = useState(0);
  const [rollsRemaining, setRollsRemaining] = useState(0);
  const [comment, setComment] = useState("");
  const [openSecond, setOpenSecond] = useState(false);
  const showDrawer = () => {
    setOpenSecond(true);
  };
  const onClose = () => {
    setOpenSecond(false);
    setOpen(false);
  };

  //updates the remaining rolls for the next order
  useEffect(() => {
    let remain = orderData.rollCount - rollsCreated;
    setRollsRemaining(remain);
  }, [orderData, rollsCreated]);

  //handles update for rolls create
  const handleRollsCreated = (value) => {
    setRollsCreated(value);
  };

  return (
    <>
      <Button disabled={orderData.splitOrder} danger onClick={showDrawer} icon={<SplitCellsOutlined />} block type="primary">
        Split order
      </Button>
      <Drawer title="Order Splitting" placement="left" onClose={onClose} open={openSecond}>
        <Divider>Splitting Order Details</Divider>
        <Image src={orderData.technicalPage} />
        <Descriptions column={1}>
          <Descriptions.Item label="Client"> {orderData.client.client}</Descriptions.Item>
          <Descriptions.Item label="Product"> {orderData.selectedProduct.product.productName}</Descriptions.Item>
          <Descriptions.Item label="Manager"> {orderData.user}</Descriptions.Item>
          <Descriptions.Item label="Box Count Required"> {orderData.boxCount}</Descriptions.Item>
          <Descriptions.Item label="Roll Count Required"> {orderData.rollCount}</Descriptions.Item>
          <Descriptions.Item label="Roll Size"> {orderData.selectedProduct.tapeWidth} mm</Descriptions.Item>
          <Descriptions.Item label="Material"> {orderData.selectedProduct.material}</Descriptions.Item>
          <Descriptions.Item label="Designer Comment"> {orderData.designerComment}</Descriptions.Item>
          <Descriptions.Item label="Sales Comment"> {orderData.salesComment}</Descriptions.Item>
        </Descriptions>
        <Divider>Split Details</Divider>
        <Descriptions column={1}>
          <Descriptions.Item label={`Rolls created (max ${orderData.rollCount})`}>
            <InputNumber
              min={0}
              max={orderData.rollCount}
              value={rollsCreated}
              onChange={handleRollsCreated}
              size="small"
              style={{ width: "100%" }}
            />
          </Descriptions.Item>
          <Descriptions.Item label="Rolls Remining for second order">
            <InputNumber min={0} value={rollsRemaining} size="small" style={{ width: "100%" }} />
          </Descriptions.Item>
          <Descriptions.Item label="Comment">
            <TextArea onChange={(event) => setComment(event.target.value)} size="small" style={{ width: "100%" }} />
          </Descriptions.Item>
        </Descriptions>
        <Button
          block
          type="primary"
          onClick={() => UpdateSplitOrder(orderData, rollsCreated, rollsRemaining, comment, user, setOpenSecond)}
          danger
        >
          Split Orders
        </Button>
      </Drawer>
    </>
  );
};
export default SplitOrderDrawer;
